module.exports = __webpack_public_path__ + "img/bug.c769d87a.svg";